export default class ExponentialIntervalGenerator {
    private baselineInterval: number;
    private maxAdditionalInterval: number;
    private failures: number;

    constructor(maxInterval: number, _baselineInterval: number) {
        this.failures = 0;
        this.baselineInterval = _baselineInterval || 0;
        this.maxAdditionalInterval = maxInterval - this.baselineInterval;
    }

    fail() {
        this.failures++;
    }

    reset() {
        this.failures = 0;
    }

    getInterval() {
        /*
            The max interval is determined by the following equation:

            2^k - 1

            We then multiple it by 1000 to convert it to milliseconds.
        */
        const expInterval = (Math.pow(2, this.failures) - 1) * 1000;
        const generatedMaxInterval = Math.min(
            expInterval,
            this.maxAdditionalInterval
        );

        // Get a random interval amount so that we don't flood the server with reconnect
        // requests from every single user at the same time.
        const interval =
            this.baselineInterval + Math.random() * generatedMaxInterval;
        return interval;
    }
}
